export default __webpack_public_path__ + "static/media/provesional_restoration_lower_16_2@2x.ba865224.png";